import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Tabs, Tab, Spinner } from 'react-bootstrap'; // Import Spinner
import TaskList from './TaskList'; // Import TaskList component
// import GroceryList from './GroceryList'; // Import GroceryList component
import DueTaskList from './DueTaskList';
import { TbFilterCog } from 'react-icons/tb';
import '../../assets/css/checklist.css'; // Import the new CSS file

const Checklist = forwardRef(({isDarkMode, isCategoryUpdateList, isTaskChannelUpdateList, isTaskProfileChannelList, isSidebarVisible}, ref) => {
  const [key, setKey] = useState('dueTaskList');
  const [loading, setLoading] = useState(false); // Add loading state
  const [localCategoryRefresh, setLocalCategoryRefresh] = useState(0); // Local refresh trigger for both tabs
  const [showFilters, setShowFilters] = useState(false);

  // Add refs for child components
  const dueTaskListRef = useRef(null);
  const taskListRef = useRef(null);

  // Callback to trigger category refresh in both tabs
  const handleCategoryDeleted = () => {
    setLocalCategoryRefresh(prev => prev + 1);
  };

  // Expose triggerShowAll function to parent
  useImperativeHandle(ref, () => ({
    triggerShowAll: () => {
      // Call Show All based on active tab
      if (key === 'dueTaskList' && dueTaskListRef.current?.triggerShowAll) {
        dueTaskListRef.current.triggerShowAll();
      } else if (key === 'tasks' && taskListRef.current?.triggerShowAll) {
        taskListRef.current.triggerShowAll();
      }
    }
  }));

  return (
    <div>
      <div className="checklist-tabs-header">
        <Tabs
          id="checklist-tabs"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-0 parent-tabs"
        >
          <Tab eventKey="dueTaskList" title="Due Tasks"></Tab>
          <Tab eventKey="tasks" title="All Tasks"></Tab>
        </Tabs>
        <button
          className={`filter-toggle-btn ${showFilters ? 'active' : ''}`}
          onClick={() => setShowFilters(!showFilters)}
          title={showFilters ? 'Hide filters' : 'Show filters'}
        >
          <TbFilterCog size={16} />
        </button>
      </div>

      {key === 'dueTaskList' && (
        <>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : (
            <DueTaskList
              ref={dueTaskListRef}
              isDarkMode={isDarkMode}
              isCategoryUpdateListTask={isCategoryUpdateList}
              isTaskChannelUpdateListTask={isTaskChannelUpdateList}
              isTaskProfileChannelList={isTaskProfileChannelList}
              isSidebarVisible={isSidebarVisible}
              localCategoryRefresh={localCategoryRefresh}
              onCategoryDeleted={handleCategoryDeleted}
              showFilters={showFilters}
            />
          )}
        </>
      )}
      {key === 'tasks' && (
        <TaskList
          ref={taskListRef}
          isDarkMode={isDarkMode}
          isCategoryUpdateListTask={isCategoryUpdateList}
          isTaskChannelUpdateListTask={isTaskChannelUpdateList}
          isTaskProfileChannelList={isTaskProfileChannelList}
          isSidebarVisible={isSidebarVisible}
          localCategoryRefresh={localCategoryRefresh}
          onCategoryDeleted={handleCategoryDeleted}
          showFilters={showFilters}
        />
      )}
    </div>
  );
});

export default Checklist;
